export default [
    ".editorconfig",
    ".prettierignore",
    ".prettierrc",
    ".prettierrc.extension",
    "odata2ts.config.ts",
    "httpyac.config.cjs",
    "tsconfig.json",
    "tsconfig.node.json",
    "vite.config.ts",
    ".vscode/settings.json",
    ".vscode/extensions.json",
    "public/robots.txt",
    "src/index.tsx",
    "src/main.tsx",
    "src/runtime.dts.ts",
    "src/vite-env.d.ts",
    "src/config/di.config.ts",
    "src/config/i18n.config.ts",
    "src/component/Connection.tsx",
    "src/component/MainLayout.tsx",
    "src/domain/App.tsx",
    "src/domain/AppModel.ts",
    "src/domain/AppRouter.tsx",
    "src/domain/AppUtil.ts",
    "src/domain/demo/I18nTestScreen.tsx",
    "src/domain/demo/TestScreen.module.scss",
    "src/domain/demo/TestScreen.tsx",
    "src/hooks/useForwardRef.ts",
    "src/hooks/useLatestCallback.ts",
    "src/hooks/useLatestRef.ts",
    "src/hooks/usePromise.ts",
    "src/i18n/de.i18n.json",
    "src/i18n/en.i18n.json",
    "src/i18n/en-GB.i18n.json",
    "src/localService/util.cjs",
    "src/localService/main-service/.gitkeep",
    "src/style/_base.scss",
];
